export const PLAYGROUND_SECRETS_SOURCE_LOCAL_STORAGE_KEY = `ls:playground-secrets-source`;

export enum PlaygroundSecretsSource {
  BROWSER = 'browser',
  WORKSPACE = 'workspace',
}

export const PLAYGROUND_LAYOUT_SIZES = {
  horizontal: {
    input: {
      default: 50,
      min: 30,
    },
    output: {
      default: 50,
      min: 30,
    },
  },
  vertical: {
    input: {
      default: 40,
      min: 20,
    },
    output: {
      default: 60,
      min: 30,
    },
  },
};
